import React, { Component, Fragment } from 'react';
import autoBind from 'react-autobind';
import { observer } from 'mobx-react';

import AutoTurs from '../coms/AutoTurs.jsx'
import AutoHotels from '../coms/AutoHotels.jsx'
import RzhdHotels from '../coms/RzhdHotels.jsx'
import RzhdTurs from '../coms/RzhdTurs.jsx'

import api from '../api/server_api.js'
import store from '../store/store.js'
import Circle from '../sys/Circle.jsx'

import MapsDirectionsBus from 'material-ui/svg-icons/maps/directions-bus';
import MapsDirectionsRailway from 'material-ui/svg-icons/maps/directions-railway';

import {
  Step,
  Stepper,
  StepLabel,
} from 'material-ui/Stepper';
import RaisedButton from 'material-ui/RaisedButton';

@observer
class NewOrder extends Component {
  
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { 
      stepIndex: 0,
      turType: '',
      step1: '',
      step2: ''
    };
  }

  componentWillMount(){
    store.setBackFunction( () => { store.replacePage('/') });

    let cb = (data) => {
      if (data) {
        store.loadData(data);
        store.setDataLoaded(true);
        }
      } 
    store.setDataLoaded(false);
    api.getData(cb);
  }

  goStep (step, data) {
    window.scrollTo(0,0);
    if ( step === 0 ) {
      store.setBackFunction( () => { store.replacePage('/') });
    }

    if ( step === 1 ) {
      if (data === 'a') this.setState({ turType: data, step1: 'Выбор тура', step2: 'Выбор отеля' });
      if (data === 'r') this.setState({ turType: data, step1: 'Выбор отеля', step2: 'Выбор заезда' });
      let that = this;
      store.setBackFunction( () => { that.goStep(0) });
    }

    if ( step === 2 ) {
      let that = this;
      store.setBackFunction( () => { that.goStep(1) });
    }

    this.setState({ stepIndex: step });
  }

  getContent() {
    const {stepIndex, turType} = this.state;
    if ( stepIndex === 0 ) {
      let divStyle = {float: "left", paddingTop: 50, width: "25%", textAlign: "center"}
      return (<Fragment> 
                <div style={divStyle}/>
                <div style={divStyle}>
                  <RaisedButton 
                    style={{height: 60}}
                    label = "АВТОБУСНЫЕ ТУРЫ"
                    icon = {<MapsDirectionsBus/>}
                    primary = {true}
                    onClick = {() => this.goStep(1, 'a') }
                    />
                </div>
                <div style={divStyle}>
                  <RaisedButton
                    style={{height: 60}}
                    label = "РЖД ТУРЫ"
                    icon = {<MapsDirectionsRailway/>}
                    primary = {true}
                    onClick = {() => this.goStep(1, 'r') } 
                    />    
                </div>
                <div style={divStyle}/>
              </Fragment>)
    }
    if ( stepIndex === 1 ) {
      if (turType === 'r') {
        return ( <RzhdHotels click = {() => this.goStep(2) }/> )
      }
      if (turType === 'a') {
        return ( <AutoTurs click = {() => this.goStep(2) }/> )
      }
    } //end stepindex 1
    if ( stepIndex === 2 ) {  
      if (turType === 'r') {
        return ( <RzhdTurs click = {() => store.pushPage('/neworder/rzhd') }/> )
      }  
      if (turType === 'a') {
        return <AutoHotels click = {() => store.pushPage('/neworder/auto')} />
      }
    } //end stepindex 2
  }

  render() {
    const {stepIndex, step1, step2} = this.state;

    return (
      <Fragment>
      <div style={{width: '100%', maxWidth: 700, margin: 'auto'}}>
        <Stepper activeStep={stepIndex}>
          <Step>
            <StepLabel>Тип тура</StepLabel>
          </Step>
          <Step>
            <StepLabel>{step1}</StepLabel>
          </Step>
          <Step>
            <StepLabel>{step2}</StepLabel>
          </Step>
        </Stepper>
      </div>

      {store.isDataLoaded || stepIndex === 0 ? this.getContent() : <Circle/>}

      </Fragment> )
  }
}

export default NewOrder;


// WEBPACK FOOTER //
// ./src/pages/NewOrder.jsx